import { type RefObject, useEffect } from "react";

export const useOnVisible = (
    target: RefObject<Element>,
    root: RefObject<Element>,
    { isEnabled, onVisible }: { isEnabled: boolean; onVisible: () => unknown },
) => {
    useEffect(() => {
        if (!isEnabled || !target.current) {
            return;
        }

        const observer = new IntersectionObserver(
            entries => {
                if (entries.some(entry => entry.isIntersecting)) {
                    onVisible();
                }
            },
            // Triggers before the very end so the next page is ready when the user reaches it
            { root: root.current, rootMargin: "0px 0px 120px 0px" },
        );

        observer.observe(target.current);

        return () => observer.disconnect();
    }, [isEnabled, onVisible, root, target]);
};
